<template>
    <b-container class="bv-example-row">
        <b-row class="justify-content-center align-items-center">
            <b-card class="col-lg-5 col-md-7 mt-5" bg-variant="light">
                <b-card-body class="px-lg-5 py-lg-1">
                    <template v-if="submitted">
                        <b-card-text class="text-center text-muted mb-4 mt-4">
                            <h5 class="display-4">Password Changed!</h5>
                        </b-card-text>
                        <b-card-text class="text-center text-muted mb-4 mt-4">
                            Click the button below to login!
                        </b-card-text>
                        <b-row class="justify-content-center">
                            <b-button variant="primary" @click="backToLogin()">Back To Login</b-button>
                        </b-row>
                    </template>
                    <template v-else>
                        <b-card-text class="text-center text-muted mb-4 mt-4">
                            <h5 class="display-4">Reset Your Password</h5>
                        </b-card-text>
                        <b-card-text class="text-center text-muted mb-4">
                            <small>Reset your email address and password</small>
                        </b-card-text>
                        <b-alert variant="danger" :show="errors.has('token')">{{
                                errors.first('token')
                        }}</b-alert>

                        <b-form role="form" @submit.prevent="submit">
                            <input type="hidden" name="token" />
                            <b-form-group class="mb-3" label="Email" label-for="forgot-password-email">
                                <b-form-input v-model="model.email" required type="email" id="forgot-password-email">
                                </b-form-input>
                            </b-form-group>
                            <b-form-group label="Password" label-for="forgot-password-password" ref="password">
                                <b-form-input id="forgot-password-password" type="password" v-model="model.password"
                                    required>
                                </b-form-input>
                            </b-form-group>
                            <b-form-group label="Retype Password" type="password"
                                label-for="forgot-password-confirm-password">
                                <b-form-input type="password" v-model="model.password_confirmation"
                                    id="forgot-password-confirm-password" required></b-form-input>
                            </b-form-group>
                            <div class=" text-right">
                                <b-button class="my-4" type="submit" variant="primary"
                                    :disabled="submitting ? true : false">{{
        submitting
            ? 'Submitting...'
            : 'Recover Your Password'
                                    }}</b-button>
                            </div>
                        </b-form>
                    </template>
                </b-card-body>
            </b-card>
        </b-row>
    </b-container>
</template>
<script>
import api from '@/api/auth'
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'change-password',
    data() {
        return {
            submitting: false,
            signInError: false,
            // if successfully submitted
            submitted: false,
            model: {
                email: null,
                password: null,
                password_confirmation: null,
            },
        }
    },
    mixins: [popupMixins],
    methods: {
        async submit() {
            try {
                this.submitting = true
                const valid = await this.$validator.validate();
                if (!valid) {
                    throw new Error("Invalid")
                }
                const { token } = this.$route.query
                const { email,
                    password,
                    password_confirmation, } = this.model
                if (password !== password_confirmation) {
                    throw new Error("Password Not Confirmed!")
                }
                const data = {
                    email,
                    password,
                    password_confirmation,
                    token,
                }
                console.log("data:--", data)
                await api.resetPassword(data)
                // route to dashboard
                this.submitted = true
                this.doToast(
                    'Success',
                    'Password Reset Successfully',
                    'success'
                )
            }
            catch (error) {

                /*   let messages = error.response.data.error.message
                  // show error
                  this.signInError = true
                  for (let field in messages) {
                      for (let e of messages[field]) {
                          this.$validator.errors.add({
                              scope: null,
                              field,
                              msg: e,
                          })
                      }
                  } */

                console.error("submit", error)
                this.doToast(
                    'Error',
                    `Settings failed to update. ${error.message || 'System Error!'}`,
                    'danger'
                )
            }
            finally {
                this.submitting = false
            }

        },

        backToLogin() {
            this.$router.push('/login')
        },
    },
}
</script>
<style>

</style>
